var React = require('react');

function AccessibilitySymbol (props) {
    return React.createElement("svg",props,React.createElement("g",null,[React.createElement("path",{"d":"m555.86 403.23-42.801 19.145-63.977-141.8h-151.1l-1.7539-31.754h110.45v-41.68h-112.76l-5.2031-94.078c16.504-7.4648 27.977-23.773 27.977-42.734 0-26.02-21.547-47.105-48.125-47.105s-48.125 21.09-48.125 47.105c0 18.391 10.793 34.277 26.492 42.035l11.613 209.89h163.61l69.984 155.14 80.73-36.117z","fill":"currentColor","key":0}),React.createElement("path",{"d":"m302.43 485.53c-68.02 0-123.36-55.34-123.36-123.36 0-39.008 18.223-73.824 46.582-96.441l-2.6641-48.16c-50.977 28.117-85.598 82.383-85.598 144.6 0 91.004 74.039 165.04 165.04 165.04 61.902 0 115.91-34.273 144.16-84.816l-23.883-52.938c-12.457 54.922-61.637 96.066-120.28 96.066z","fill":"currentColor","key":1})]));
}

AccessibilitySymbol.defaultProps = {"version":"1.1","viewBox":"0 0 700 530"};

module.exports = AccessibilitySymbol;

AccessibilitySymbol.default = AccessibilitySymbol;
